import React from 'react'
import './Subtotal.css'
import CurrencyFormat from 'react-currency-format';
import { useStateValue } from './StateProvider';
// import { useHistory } from 'react-router';
import {useHistory}from 'react-router-dom'
function Subtotal() {
  const [{basket},dispatch]=useStateValue();
  const history=useHistory()
  const getBasketTotal=(basket)=>basket?.reduce((amount,item)=>
  item.price+amount,0)
    return (
        <div className="subtotal">
            <CurrencyFormat
        renderText={(value) => (
          <div>
            <p>
              Subtotal ({basket.length} items): <strong>{value}</strong>
            </p>
            <small className="subtotal__gift">
              <input type="checkbox" /> This order contains a gift
            </small>
          </div>
        )}
        decimalScale={2}// add two digits after decimal 10.99
        value={getBasketTotal(basket)} // to render the value
        displayType={'text'}// the display  is like text
        thousandSeparator={true}// add comma on $ 12,000
        prefix={'$'}//$ sign 
      />
      <button onClick={(e) => history.push('/Payment')}>
        Proceed to Checkout
      </button>
        </div>
    )
}

export default Subtotal
